import React, { useMemo } from 'react';
import { CompanyService } from '../../../services/Companies'; // ユーザー情報API
import * as _ from 'lodash';
import DropdownSelector from '../../dropdowns/DropdownSelector';

class UserSerchDropDownForforeman extends DropdownSelector {
  /**
   * setValue の override
   */
  setValue = () => {
    const { ...state } = this.state;
    state.selected = state.temporarySelected;
    state.selectAll = state.temporarySelectAll;
    state.selectedName = state.temporarySelectedName;
    state.opened = this.state.multiple;

    const allOptions = _.unionBy(
      state.options,
      this.bindResponseDataToObject(this.props.selectedOptions),
      state.temporaryHiddenSelectedOptions,
      'id'
    );
    _.each(allOptions, option => {
      // apiでの保存対象
      option.password_reset_notice_flag = _.includes(state.selected, option.id);
    });

    this.setState(state, () => {
      // プルダウンの呼び出しコンポーネントでの処理
      this.props.onSelect(allOptions);
    });
  };

  /**
   * bindResponseDataToObject のoverride
   * @param {object} responseData
   */
  bindResponseDataToObject = responseData => {
    const tmp = _.map(responseData, data => {
      let _name;
      if (data.name_mei && data.name_sei) {
        _name = `${data.name_sei} ${data.name_mei}`;
      } else {
        _name = data.name;
      }
      return {
        order_number: data.order_number ? data.order_number : 0,
        name: _name,
        password_reset_notice_flag: data.password_reset_notice_flag,
        [this.state.valueName]: String(data[this.state.valueName]), // id
      };
    });
    return tmp;
  };
}

/**
 * 現場に設定された協力会社の複数選択 ドロップダウン
 * @param selectedValues {array} 初期値
 * @param onSelect {func} 選択処理時のcallback処理
 */
export const UserSerchDropDown = ({
  selectedValues,
  label = '未選択',
  onSelect,
  userCompany,
  isHideHiddenItem,
}) => {
  const filteredSelectedValues = useMemo(() => {
    return _.filter(selectedValues, { password_reset_notice_flag: true });
  }, [selectedValues]);

  return (
    <UserSerchDropDownForforeman
      className='form-element__element'
      label={label}
      multiple={true}
      api={params => CompanyService.partnerUsers(userCompany, params)}
      apiParams={{}}
      apiSearchKey='fullname'
      selectedValues={
        // objectであるため
        _.map(filteredSelectedValues, value => String(value.id))
      }
      keyName='name'
      valueName='id'
      apiBindDataKey={'users'}
      onSelect={onSelect}
      dropdownSelectStyle={{ width: '240px' }}
      isHideHiddenItem={isHideHiddenItem}
      selectedOptions={filteredSelectedValues}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/UserSerch.jsx